if (!customElements.get("wishlist-button")) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.button = null;
      this._isActive = null;
      this._boundSyncState = this.syncState.bind(this);
      this._boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector(".js-wishlist-toggle");
      if (!this.button || !this.dataset.productHandle) return;

      this.button.addEventListener("click", this._boundHandleClick);
      window.addEventListener("wishlist:updated", this._boundSyncState);

      if (window.wishlistService?.isReady) {
        this.syncState();
      } else {
        window.addEventListener("wishlist:ready", this._boundSyncState, {
          once: true,
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener("wishlist:updated", this._boundSyncState);
      window.removeEventListener("wishlist:ready", this._boundSyncState);
      if (this.button) {
        this.button.removeEventListener("click", this._boundHandleClick);
      }
    }

    handleClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (!window.theme?.customerId) {
        window.location.href = window.theme?.routes?.accountLogin || "/account/login";
        return;
      }

      if (!window.wishlistService) return;

      const handle = this.dataset.productHandle;
      if (window.wishlistService.has(handle)) {
        window.wishlistService.remove(handle);
      } else {
        window.wishlistService.add({
          handle,
          productId: this.dataset.productId,
          variantId: this.dataset.variantId,
        });
      }
    }

    syncState() {
      if (!window.wishlistService || !this.button) return;
      const isActive = window.wishlistService.has(this.dataset.productHandle);
      if (isActive === this._isActive) return;
      this._isActive = isActive;
      this.button.setAttribute("aria-pressed", String(isActive));
      this.button.classList.toggle("is-active", isActive);
    }
  }

  customElements.define("wishlist-button", WishlistButton);
}
